import { render, staticRenderFns } from "./form-shipping.vue?vue&type=template&id=69619312&scoped=true"
import script from "./form-shipping.vue?vue&type=script&setup=true&lang=js"
export * from "./form-shipping.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69619312",
  null
  
)

export default component.exports